import { Instance, SnapshotIn, SnapshotOut, flow, types } from "mobx-state-tree"
import { withSetPropAction } from "./helpers/withSetPropAction"
import { withStatusModel } from "./helpers/withStatusModel";
import { unzip } from 'react-native-zip-archive';
// import { unzip } from 'react-native-gzip';
/**
 * Model description here for TypeScript hints.
 */
import { IntegrationsOfflineByUserModel, IntegrationsCacheByUserModel } from "./helpers/typesModels";
import { Platform } from "react-native";
import * as SQL from "../utils/storage/sqlite";

import * as FileSystem from "expo-file-system";
import { readLastSync, saveLastSync } from "../utils/general";
const AFTER_HOOK_LIBS = `
function getGPSDistance(lat1, lon1, lat2, lon2) {
    if ((lat1 == lat2) && (lon1 == lon2)) {
        return 0;
    } else {
        var radlat1 = Math.PI * lat1/180;
        var radlat2 = Math.PI * lat2/180;
        var theta = lon1-lon2;
        var radtheta = Math.PI * theta/180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180/Math.PI;
        dist = dist * 60 * 1.1515 * 1.609344;
        return dist;
    }
};

function findField(item, fieldId) {
    function _findField(lstFields) {
        return lstFields.reduce(function (obj, el) {
            if (el.id == fieldId) return el;
            if (obj == undefined && el.nodes) obj = _findField(el.nodes);
            return obj;
        }, undefined);
    }
    return item.pages.reduce(function (obj, page) {
        if (obj) return obj;
        return _findField(page.fields);
    }, undefined);
};

function table_getListOfColumn(table, colNumber, hasHeaderRow, uniqueValues, conditionCol, conditionValue) {
    return table.reduce(function (list, row, idy) {
        if (idy == 0 && hasHeaderRow) return list;
        var value = row[colNumber];
        if (value && (!uniqueValues || list.indexOf(value) < 0)) {
            if (conditionCol == undefined) list.push(value);
            else if (row[conditionCol].toString().toLowerCase() == conditionValue.toString().toLowerCase()) list.push(value);
        }
        return list;
    }, []).sort();
};

function csv_getTable(data, colSeparator) {
    return data.split("\\n").map(function(row) {
        return row.split(colSeparator)
    });
};

function csv_getListOfColumn(data, colSeparator, colNumber, hasHeaderRow, uniqueValues, conditionCol, conditionValue) {
    return table_getListOfColumn(csv_getTable(data, colSeparator), colNumber, hasHeaderRow, uniqueValues, conditionCol, conditionValue);
};

function gsheet_getListOfColumn(data, colNumber, hasHeaderRow, uniqueValues, conditionCol, conditionValue) {
    return table_getListOfColumn(data.values, colNumber, hasHeaderRow, uniqueValues, conditionCol, conditionValue);
};
`;

export const IntegrationsStoreModel = types
  .model("IntegrationsStore")
  .props({
    integrationsOfflineByUserModel: types.array(IntegrationsOfflineByUserModel),
    integrationsCacheByUserModel: types.array(IntegrationsCacheByUserModel)
  })
  .actions(withSetPropAction)
  .extend(withStatusModel)
  .actions((store) => ({
    myIntegration: (integrationId: string) => {
      let idx = store.integrationsOfflineByUserModel.findIndex(
        (integration) =>
          // @ts-ignore
          integration.userId == store.parent.authenticationStore.userIdLogged
          && integration.id == integrationId
      );

      if (idx >= 0)
        // @ts-ignore
        return { idx, object: JSON.parse(JSON.stringify(store.integrationsOfflineByUserModel[idx])) };
      return null;
    },
    myIntegrationCache: (integrationId: string, dynamicParams: string) => {
      let idx = store.integrationsCacheByUserModel.findIndex(
        (integration) =>
          // @ts-ignore
          integration.userId == store.parent.authenticationStore.userIdLogged
          && integration.id == integrationId
          && integration.dynamicParams == dynamicParams
      );

      if (idx >= 0)
        // @ts-ignore
        return { idx, object: JSON.parse(JSON.stringify(store.integrationsCacheByUserModel[idx])) };
      return null;
    },
  }))
  .actions((store) => ({
    updateOffline: (integrationId: string, definition: any, response: any) => {
      console.log("init updIntegrationOffline", integrationId);
      let myIntegration = store.myIntegration(integrationId);
      let list = store.integrationsOfflineByUserModel?.toJSON() || [];
      if (myIntegration) {
        myIntegration.object.definition = definition || myIntegration.object.definition;
        myIntegration.object.response = response || myIntegration.object.response
        myIntegration.object.lastSync = Date.now();
        list[myIntegration.idx] = myIntegration.object;
      } else {
        console.log("Integracion Nueva", integrationId)
        let newIntegration = IntegrationsOfflineByUserModel.create({
          id: integrationId, userId: store.parent.authenticationStore.userIdLogged,
          definition, response, lastSync: Date.now()
        });
        list.push(newIntegration);
      }
      store.setProp("integrationsOfflineByUserModel", list);
      console.log("end updIntegrationOffline", integrationId);
      return true;
    },
    updateCache: flow(function* updateCache(integrationId: string, dynamicParams: any, response: any) {
      console.log("init updateCache", integrationId);
      let myIntegration = store.myIntegrationCache(integrationId, dynamicParams);
      let list = store.integrationsCacheByUserModel?.toJSON() || [];
      if (myIntegration) {
        console.log("Integracion Existente", integrationId)
        myIntegration.object.dynamicParams = dynamicParams || myIntegration.object.dynamicParams;
        myIntegration.object.response = response || myIntegration.object.response
        myIntegration.object.lastSync = Date.now();
        list[myIntegration.idx] = myIntegration.object;
      } else {
        console.log("Integracion Nueva", integrationId)
        let newIntegration = IntegrationsCacheByUserModel.create({
          id: integrationId, userId: store.parent.authenticationStore.userIdLogged,
          dynamicParams, response, lastSync: Date.now()
        });
        list.push(newIntegration);
      }
      store.setProp("integrationsCacheByUserModel", list);
      console.log("end updateCache", integrationId);
      return true;
    }),
    removeOffline: (integrationId: string) => {
      let myIntegration = store.myIntegration(integrationId);;
      if (myIntegration)
        store.integrationsOfflineByUserModel.splice(myIntegration.idx, 1);
    },
    removeAll: (integrationId: string) => {
      store.integrationsOfflineByUserModel.splice(0);
    },
  }))
  .actions((store) => ({
    downloadOffline: flow(function* downloadOffline(subscriptions: [any]) {
      const downloadCallback = (downloadProgress, fileName, idArchivo, sizeFile) => {
        // totalBytesWritten: bytes descargados hasta el momento
        const totalBytesWritten = downloadProgress.totalBytesWritten;
        // totalBytesExpectedToWrite: tamaño total del archivo (desde el header Content-Length)
        const totalBytesExpectedToWrite = downloadProgress.totalBytesExpectedToWrite;
        const percentage = totalBytesExpectedToWrite > 0 ? totalBytesWritten / totalBytesExpectedToWrite : -1;
        // Cálculo en Megabytes
        const writtenMB = (totalBytesWritten / (1024 * 1024)).toFixed(2);
        const totalMB = sizeFile > 0 ? (sizeFile / (1024 * 1024)).toFixed(2) : "N/A";

        // Aquí podés actualizar el estado de tu aplicación o mostrar una barra de progreso

        // Aquí actualizás el estado de React para mostrar en la UI
        console.log(idArchivo, `${fileName}: ${writtenMB} MB de ${totalMB} MB`);
        store.updLoadingInfo({ id: idArchivo, title: `${fileName}: ${writtenMB} MB de ${totalMB} MB` })


      };
      let lstIntegrationId: string[] = [];
      subscriptions.forEach(dept => {
        dept.forms.forEach(form => {
          form.pages.forEach(page => {
            page.fields.forEach(field => {
              if (field.integration && field.integration.id)
                lstIntegrationId.indexOf(field.integration.id) === -1 ? lstIntegrationId.push(field.integration.id) : null;
              field.nodes?.forEach(node => {
                if (node.integration && node.integration.id)
                  lstIntegrationId.indexOf(node.integration.id) === -1 ? lstIntegrationId.push(node.integration.id) : null;
                node.nodes?.forEach(node2 => {
                  if (node2.integration && node2.integration.id)
                    lstIntegrationId.indexOf(node2.integration.id) === -1 ? lstIntegrationId.push(node2.integration.id) : null;
                });
              });
            });
          });
        });
      });
      console.log("Integrations Offline", lstIntegrationId)
      const loadInfoInit = store.addLoadingInfo({ title: "Integraciones Offline a Sincronizar: ".concat(lstIntegrationId.length.toString()), spinner: lstIntegrationId.length > 0 })

      if (lstIntegrationId.length == 0)
        return;
      store.addLoadingInfo({ title: "... descargando configuraciones ..." })
      const respInts = yield store.api().getIntegrations(lstIntegrationId);
      if (respInts && respInts.status == 200) {
        const jsonInts = yield respInts.json();
        const seenS3Tables: string[] = [];
        yield Promise.all(jsonInts.filter(int => {
          if (int.configuration.connection.urlType === "s3") {
            const s3Info = int.configuration.connection.s3;
            store.updateOffline(int.id, int, s3Info.tableName);
            if (Platform.OS=="web" || !(int.configuration.connection.s3?.columns?.length > 0) || seenS3Tables.indexOf(int.configuration.connection.s3.tableName) >= 0)
              return false;
            
            seenS3Tables.push(int.configuration.connection.s3.tableName);
          }
          return true;
        }).map(async (integration: any, idx: number) => {
          if (integration.configuration.connection.urlType === "s3") {
            try {
              if (Platform.OS === 'ios' || Platform.OS === 'android') {
                const s3Info = integration.configuration.connection.s3;
                const loadInfoInitX = store.addLoadingInfo({ title: " ... S3 sincronizando :".concat(s3Info.tableName), spinner: true })
                const SQLITE_PATH = `${FileSystem.documentDirectory}${integration.tenantId}_${s3Info.tableName}.sqlite`; // Ubicación temporal
                const lastSync = await readLastSync(SQLITE_PATH + ".lastSync");
                console.log("Integration Offline S3 ", idx, integration.tenantId, integration.name, lastSync)
                const respInt = await store.api().getIntegration(integration.id, {}, true);
                const wsResp = await respInt.json();
                if (lastSync == undefined || lastSync == "") {
                  // Descargar el archivo SQLite desde la URL proporcionada
                  const result = await store.api().getS3(integration.id, wsResp.response.sqlite.uriZIP, SQLITE_PATH.concat(".zip"), downloadCallback, s3Info.tableName, loadInfoInitX, wsResp.response.sqlite.ContentLengthZIP);
                  console.log(`✅ Archivo SQLite guardado en: ${result.uri}`);
                  try {
                    await unzip(result.uri, `${FileSystem.documentDirectory}`)
                  } catch (e) {
                    console.log("Error al descomprimir", e)
                  }

                  console.log(`✅ Expandiendo SQLite guardado en: ${result.uri}`);
                  await SQL.loadFromDownloaded(SQLITE_PATH, `${integration.tenantId}_${s3Info.tableName}`);
                  await FileSystem.deleteAsync(SQLITE_PATH);
                  saveLastSync(SQLITE_PATH + ".lastSync");
                } else {
                  // Traer del servidor solo los cambios desde lastSync
                  for (let index = 0; index < wsResp.response.delta.length; index++) {
                    const element = wsResp.response.delta[index];
                    console.log("Comparando ", element.LastModified, lastSync)
                    if (element.LastModified > lastSync) {
                      console.log("Descargar delta ", element.LastModified, element.uri)
                      try {
                        const DELTA_PATH = `${FileSystem.documentDirectory}${element.uri}`;
                        const result = await store.api().getS3(integration.id, element.uri, DELTA_PATH, downloadCallback, s3Info.tableName, loadInfoInitX);

                        if (result.status !== 200) {
                          console.error(`Error en la descarga. Código de estado: ${result.status}`);
                          throw new Error(`Fallo la descarga GET. Código: ${result.status}`);
                        }

                        console.log(`✅ Archivo DELTA ha guardado en: ${result.uri}`);
                        await SQL.updTableFromFileContent(integration.tenantId,s3Info, result.uri);
                        try { await FileSystem.deleteAsync(result.uri); } catch (e) { }

                      } catch (error) {
                        console.error("❌ Fallo durante la descarga de la integración:", error);
                        throw error;
                      }
                    }
                  }
                  saveLastSync(SQLITE_PATH + ".lastSync");
                }

                store.updLoadingInfo({ id: loadInfoInitX, spinner: false })

              } else {
                store.addLoadingInfo({ title: " Integration Offline S3 no soportado en Web:".concat(integration.name) })
                console.log("Integration Offline S3 no soportado en Web", idx, integration.name)
              }
            } catch (e) {
              console.log("Error en integración S3", integration.name, e)
            }

          } else if (integration.configuration.connection.allowOffline) {
            const loadInfoInitX = store.addLoadingInfo({ title: " ... ".concat(integration.name) })
            let myIntegration = store.myIntegration(integration.id) || { object: undefined };
            if (myIntegration.object?.lastSync != undefined && ((Date.now() - myIntegration.object.lastSync) / (1000 * 60 * 60)) < (integration.configuration.connection.refreshOffline || 8))
              return;
            console.log("Integration Offline", idx, integration.name, "lastSync", myIntegration.object?.lastSync, "get");
            const respInt = await store.api().getIntegration(integration.id, {}, true);
            console.log("Integration Offline", idx, integration.name, "end get");
            if (respInt) {
              const wsResp = await respInt.text();
              if (respInt.status == 200)
                store.updateOffline(integration.id, integration, wsResp);
              store.updLoadingInfo({ id: loadInfoInitX, spinner: false })
            }
          } else
            store.removeOffline(integration.id);

        }));
        console.log("TERMINO TODAS LAS OFFLINE")
        store.updLoadingInfo({ id: loadInfoInit, spinner: false });
      }
    }),
    getIntegration: flow(function* getIntegration(integrationId, dynamicParams) {
      console.log("getIntegration", 2,integrationId)
      let integration = store.myIntegration(integrationId);
      console.log("getIntegration", 3, integration?.object?.definition?.name)
      if (integration && (integration.object?.definition?.configuration?.connection?.allowOffline || integration.object.definition.configuration.connection.urlType === "s3")) {
        console.log("getIntegration", "OFFLINE", integrationId)
        async function afterHook(dataString, params) {
          console.log("afterHook000",params)
          for (const param in params) {
            if (params[param] === "{currentUser.email}")
              params[param] = store.parent.authenticationStore.userInfo.user.email;
            if (params[param] === "{currentUser}")
              params[param] = store.parent.authenticationStore.userInfo.user;
            if (params[param] === "{currentUser.id}")
              params[param] = store.parent.authenticationStore.user.id;
            if (params[param] === "{formId}")
              params[param] = store.parent.itemsStore.itemActive.formId;
            if (params[param] === "{deptId}")
              params[param] = store.parent.itemsStore.itemActive.deptId;
          }
          console.log("afterHook001",params)
          let data;
          
          try {
            if (integration.object.definition.configuration.connection.urlType == "s3") {
              console.log("Integration S3", integration.object.definition.configuration.connection.s3.tableName)
              data = await SQL.getDbConnection(integration.object.definition.tenantId.concat("_",integration.object.definition.configuration.connection.s3.tableName));
 
              const codeJS = AFTER_HOOK_LIBS.concat(";\n ", integration.object.definition.configuration.afterHook);
              console.log("codeJS", codeJS, params)
              const runMe = new Function(['data', 'params'], codeJS);
              const promise = runMe(data, params);
              try{
                const ret= await promise;
                return ret;
              }catch(e){
                console.log("Error ejecutando afterHook S3", e)
                return null;
              }
            }
            else
             if (integration.object.definition.configuration.type == "json")
                data = await JSON.parse(dataString);
               else if (integration.object.definition.configuration.type == "text")
                data = await JSON.parse(dataString);
             
              else {
                console.log("Tipo de integración no soportada para offline:", integration.object.definition.configuration.type);
                data = (dataString);
              }

            const codeJS = AFTER_HOOK_LIBS.concat(";\n ",
              "function runMe(data,params){", integration.object.definition.configuration.afterHook, ";};", "let data=", JSON.stringify(data), ";let params=", JSON.stringify(params), ";runMe(data,params)");
            const ret= eval?.(codeJS);
           console.log("getIntegration", 3, integration.object?.definition?.name,ret)
            console.log("getIntegration", 3, integration.object?.definition?.name,ret)
            return ret;
          } catch (e) {
            console.log("afterHook", e.message);
            return null;
          }
        }
        let datastring = "";
        if (integration.object.definition.configuration.connection.urlType != "s3")
          datastring = JSON.parse(integration.object.response).response
        return yield afterHook(datastring,
          { ...integration.object?.definition?.configuration?.connection?.staticParams, ...integration.object?.definition?.configuration?.connection?.dynamicParams, ...dynamicParams }
        );
      } else {
        for (const param in dynamicParams) {
          if (dynamicParams[param] === "{formId}")
            dynamicParams[param] = store.parent.itemsStore.itemActive.formId;
          if (dynamicParams[param] === "{deptId}")
            dynamicParams[param] = store.parent.itemsStore.itemActive.deptId;
        }

        const respInt = yield store.api().getIntegration(integrationId, dynamicParams, false);
        if (respInt) {
          console.log("Integration Online ", integrationId)
          if (respInt.status == 200) {
            const responseIntegration = yield respInt.json();
            yield store.updateCache(integrationId, JSON.stringify(dynamicParams), JSON.stringify(responseIntegration.response));
            return responseIntegration.response;
          } else {
            let fromCache = store.myIntegrationCache(integrationId, JSON.stringify(dynamicParams));
            if (fromCache)
              return fromCache.object.response;
            return null;
          }
        }
        return null;
      }
    }),
    getS3Integrations: flow(function*  getS3Integrations() {
      let lst = [];
      for(let i=0;i<store.integrationsOfflineByUserModel.length; i++){
      
          const integration = store.integrationsOfflineByUserModel[i].toJSON();
          if(integration.userId ==  store.parent.authenticationStore.userIdLogged
          && integration.definition.configuration.connection.urlType === "s3"){
            const s3Info = integration.definition.configuration.connection.s3
            if(lst.findIndex( (itm) => itm.tableName == s3Info.tableName) == -1){
              console.log("integration", integration.definition.name)
              const PATH = `${FileSystem.documentDirectory}SQLite/${integration.definition.tenantId}_${s3Info.tableName}.sqlite`;
              //const PATH = `${FileSystem.documentDirectory}SQLite/${s3Info.tableName}.sqlite`;
              const infoFile = yield FileSystem.getInfoAsync(PATH);
              lst.push({id:integration.definition.id, path:PATH, definition:integration.definition, infoFile:infoFile,tableName: s3Info.tableName});
            }
          }
            
        }
     
      return lst;
    })
  })) // eslint-disable-line @typescript-eslint/no-unused-vars  

export interface IntegrationsStore extends Instance<typeof IntegrationsStoreModel> { }
export interface IntegrationsStoreSnapshotOut extends SnapshotOut<typeof IntegrationsStoreModel> { }
export interface IntegrationsStoreSnapshotIn extends SnapshotIn<typeof IntegrationsStoreModel> { }
export const createIntegrationsStoreDefaultModel = () => types.optional(IntegrationsStoreModel, {})
